import type { DocMigration } from "../docMigration";

function migrateElement(element: any): void {
  if (element.type === "NOTE" && element.path !== undefined) {
    delete element.path;
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_422: DocMigration = {
  maxSchemaVersion: "0.0.422",
  description: "Remove stray path properties from note annotations",
  apply(json: any) {
    for (const annotationKey in json.annotation) {
      migrateElement(json.annotation[annotationKey]);
    }
    return json;
  },
};

export default migration_0_0_422;
